'use client';
import React, { useEffect, useRef, useState } from 'react';
import get from 'lodash/get';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { BORDER_COLORS } from '@/common/constants';
import { twMerge } from 'tailwind-merge';
function DocumentAutoScroll({ posstDocumentType, websiteCode }) {
  const scrollRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);

  // Nhân đôi nội dung để cuộn vô hạn
  const renderList = () => (
    <>
      {(posstDocumentType ?? []).map((doc, index) => (
        <div key={index} className="relative !mb-1">
          <Link href={websiteCode ? `/sub/${websiteCode}/van-ban/${doc?.slug}` : `/van-ban/${doc?.slug}`}>
            <div className="absolute inset-0 opacity-5 rounded-lg">
              <div className="w-full h-full bg-gradient-to-br from-red-100 to-red-50 rounded-lg"></div>
            </div>

            <div
              className="relative border border-gray-200 rounded-lg hover:shadow-md 
                            transition-shadow duration-300 hover:border-red-200 px-2">
              <div
                className="flex items-center"
                ref={(el) => {
                  if (el?.lastElementChild) {
                    el.lastElementChild.style.marginBottom = '0px';
                  }
                }}>
                <img src="/ic-widget.png" className="w-2 h-2 block" alt="icon" />
                <div className="flex-1 ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-blurred ck ck-content">
                  <div
                    className="pl-3 leading-5 text-xs sm:text-sm h-10 overflow-hidden! my-0! flex items-center"
                    dangerouslySetInnerHTML={{ __html: `<div class="line-clamp-2">${doc?.content ?? ''}</div>` }}
                  />
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}

      <div style={{ height: '500px' }} />
    </>
  );

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let scrollInterval;

    const startAutoScroll = () => {
      scrollInterval = setInterval(() => {
        if (!el || isHovering) return;

        el.scrollTop += 1;

        if (el.scrollTop >= el.scrollHeight / 2) {
          el.scrollTop = 0;
        }
      }, 20);
    };

    startAutoScroll();
    return () => clearInterval(scrollInterval);
  }, [isHovering]);
  return (
    <div className="bg-white overflow-hidden rounded-lg">
      <div
        ref={scrollRef}
        className="max-h-[470px] overflow-y-auto"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}>
        <div className="space-y-[2px] sm:space-y-[3px] px-1">
          {renderList()}
          {renderList()}
        </div>
      </div>
    </div>
  );
}
const NewText = ({ newTexts, websiteCode }) => {
  const t = useTranslations('');
  return (
    <div className={twMerge('border h-[100%]', BORDER_COLORS.primary)}>
      <div className="title">
        <a href="#" className="w-full font-semibold">
          {t('home.newDocument')}
        </a>
      </div>
      <DocumentAutoScroll posstDocumentType={get(newTexts, 'results', [])} websiteCode={websiteCode} t={t} />
    </div>
  );
};

export default NewText;
